import { createAnalytics } from '@3plearning/mx-teacher-analytics';

import { appEvents } from './events';
import { resolveEnabledGroups } from './feature-groups';

const APP_NAME = 'certificate-report';

const _env_ = window._env_ || ({} as Partial<Window['_env_']>);

const isPosthogEnabled = (): boolean => {
    const override = new URL(window.location.href).searchParams.get('POSTHOG_ENABLED');

    if (override === 'true') return true;
    if (override === 'false') return false;

    return String(_env_.POSTHOG_ENABLED) === 'true';
};

// With PostHog disabled no providers are registered, so every call becomes a
// no-op — nothing is sent and nothing throws.
export const analyticsClient = createAnalytics({
    app: APP_NAME,
    environment: String(_env_.ENVIRONMENT ?? ''),
    providers: {
        posthog: {
            enabled: isPosthogEnabled()
        }
    },
    enabledFeatureGroups: resolveEnabledGroups(_env_.POSTHOG_TRACKING_GROUPS),
    events: appEvents
});
